<div class="p-field ">
    <label for="category">Category</label>
    <p-dropdown
      [options]="categoriesByKind"
      [(ngModel)]="selectedCategory"
      placeholder="Select Category"
      appendTo="body"
      [filter]="true"
      filterBy="label"
      [group]="true"
      (onChange)="onCategoryChange()"
      class="products-lists-category full-width custom-dropdown"
    ></p-dropdown>
</div>

<div class="p-field">
    <label for="type">Type</label>
    <p-dropdown
      appendTo="body"
      [options]="typesByCategory"
      optionLabel="productType"
      [(ngModel)]="selectedType"
      placeholder="Select Type"
      [filter]="true"
      filterBy="productType"
      (onChange)="onTypeChange()"
      [disabled]="!selectedCategory"
      class="products-lists-type full-width custom-dropdown"
      ></p-dropdown>
</div>

<div class="p-field">
    <label for="item">Item</label>
    <p-dropdown
      optionLabel="item"
      appendTo="body"
      [options]="itemsByType"
      [(ngModel)]="selectedItem"
      placeholder="Select Item"
      (onChange)="onItemChange()"
      [filter]="true"
      filterBy="item,partNumber"
      [disabled]="!selectedType"
      class="products-lists-item full-width custom-dropdown"
    >
  
  
    <ng-template let-option pTemplate="selectedItem">
      <div class="item">
          <span id="{{option.productId}}">{{ (option.partNumber?option.partNumber+ ' - ' : '')  + option.item}}</span>
      </div>
  </ng-template>

  <ng-template let-option pTemplate="item">
      <span id="{{option.productId}}">{{(option.partNumber?option.partNumber+ ' - ' : '') + option.item}}</span>
  </ng-template>
  
  
  </p-dropdown>
</div>
